import {Inject, Injectable} from '@angular/core';
import {SignalStore} from 'src/app/shared/functions/store.functions';
import {AppState} from '../models/app.model';
import {NavigationEnd, Router} from '@angular/router';
import {filter} from 'rxjs';
import {IMenu, IMenuItem} from '../models/menu.model';

@Injectable({
  providedIn: 'root'
})
export class RoutingService {
  private currentRoute: string = '';

  constructor(
    @Inject('app-store') private readonly appStore: SignalStore<AppState>,
    private readonly router: Router,
  ) {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event) => {
        this.currentRoute = this.router.routerState.snapshot.url
      });
  }

  getCurrentMenuItem() {
    return this.search(this.appStore.state().menu, this.currentRoute);
  }

  getCurrentRouteUrl() {
    return this.currentRoute;
  }

  getTreeMenuItems() {
    return this.createTrees(this.appStore.state().menu, this.currentRoute);
  }

  private createTrees(menu: IMenu, link: string): IMenuItem[] {
    for (const menuItem of menu) {
      if (menuItem.subMenu) {
        // Cerca nell'array subMenu in modo ricorsivo
        const foundInSubMenu = this.createTrees(menuItem.subMenu, link);
        if (foundInSubMenu.length > 0) {
          foundInSubMenu.unshift(menuItem);
          return foundInSubMenu;
        }
      }
      if ((menuItem.link && link.includes(menuItem.link)) || link.includes(menuItem.name)) {
        return [menuItem];
      }
    }

    // Nessun elemento trovato con il link specificato
    return [];
  }

  private search(menu: IMenu, link: string): IMenuItem | undefined {
    for (const menuItem of menu) {
      if (menuItem.subMenu) {
        // Cerca nell'array subMenu in modo ricorsivo
        const foundInSubMenu = this.search(menuItem.subMenu, link);
        if (foundInSubMenu) {
          return foundInSubMenu;
        }
      }
      if ((menuItem.link && link.includes(menuItem.link)) || link.includes(menuItem.name)) {
        return menuItem;
      }
    }

    // Nessun elemento trovato con il link specificato
    return undefined;
  }
}
